/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { PublishedBoardsApiConfiguration } from '../published-boards-api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { PublishedBoardResponse as ApiPublishedBoardResponse } from '../models/api/published-board-response';
import { PublishedBoardV2Response as ApiPublishedBoardV2Response } from '../models/api/published-board-v-2-response';
import { getPublishedBoard } from '../fn/published-boards/get-published-board';
import { GetPublishedBoard$Params } from '../fn/published-boards/get-published-board';
import { getV2PublishedBoard } from '../fn/published-boards/get-v-2-published-board';
import { GetV2PublishedBoard$Params } from '../fn/published-boards/get-v-2-published-board';
import { ping } from '../fn/published-boards/ping';
import { Ping$Params } from '../fn/published-boards/ping';

@Injectable({ providedIn: 'root' })
export class PublishedBoardsService extends BaseService {
  constructor(config: PublishedBoardsApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `ping()` */
  static readonly PingPath = '/ping';

  /**
   * Ping.
   *
   * Pings service and check if it is up
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ping()` instead.
   *
   * This method doesn't expect any request body.
   */
  ping$Response(params?: Ping$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return ping(this.http, this.rootUrl, params, context);
  }

  /**
   * Ping.
   *
   * Pings service and check if it is up
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ping$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ping(params?: Ping$Params, context?: HttpContext): Observable<string> {
    return this.ping$Response(params, context).pipe(map((r: StrictHttpResponse<string>): string => r.body));
  }

  /** Path part for operation `getPublishedBoard()` */
  static readonly GetPublishedBoardPath = '/v1/{boardId}';

  /**
   * Get Published Board.
   *
   * Get the latest Published Board
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPublishedBoard()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPublishedBoard$Response(
    params: GetPublishedBoard$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ApiPublishedBoardResponse>> {
    return getPublishedBoard(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Published Board.
   *
   * Get the latest Published Board
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPublishedBoard$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPublishedBoard(params: GetPublishedBoard$Params, context?: HttpContext): Observable<ApiPublishedBoardResponse> {
    return this.getPublishedBoard$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiPublishedBoardResponse>): ApiPublishedBoardResponse => r.body)
    );
  }

  /** Path part for operation `getV2PublishedBoard()` */
  static readonly GetV2PublishedBoardPath = '/v2/{boardId}';

  /**
   * Get Published Board.
   *
   * Get the latest Published Board
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getV2PublishedBoard()` instead.
   *
   * This method doesn't expect any request body.
   */
  getV2PublishedBoard$Response(
    params: GetV2PublishedBoard$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ApiPublishedBoardV2Response>> {
    return getV2PublishedBoard(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Published Board.
   *
   * Get the latest Published Board
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getV2PublishedBoard$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getV2PublishedBoard(
    params: GetV2PublishedBoard$Params,
    context?: HttpContext
  ): Observable<ApiPublishedBoardV2Response> {
    return this.getV2PublishedBoard$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiPublishedBoardV2Response>): ApiPublishedBoardV2Response => r.body)
    );
  }
}
